import moment from 'moment';
import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';

import { updateCampaignDayBudgetInfoRemote } from '../../actions/campaigns-grid';
import {
    GridCampaignStatusCell,
    GridCampaignStatusCellProps
} from '../../components/GridCampaignStatusCell/GridCampaignStatusCell';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellKey } from '../../service/GridHelpers/GridHelpers';
import { DayBudgetValue, WalletDayBudgetValue } from '../../typings/budget';
import { DailyBudgetLimit } from '../../typings/constants';
import { StatusInfo } from '../../typings/domain';
import { CurrencyCode, GdWalletAction } from '../../typings/graphql-grid';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    campaignId: string;
    columnName: string;
    name: string;
    statusInfo: StatusInfo;
    agencyId: string | null;
    canPay: boolean;
    currency: CurrencyCode;
    dayBudgetValue?: DayBudgetValue;
    dailyBudgetLimit: DailyBudgetLimit;
    login: string;
    walletBudget?: WalletDayBudgetValue;
    walletActions: Array<GdWalletAction>;
    isTextVisible: boolean;
    startDate: moment.Moment;
    endDate?: moment.Moment;
}

export type StateProps = TStateProps<GridCampaignStatusCellProps, OwnProps>;

export type DispatchProps = TDispatchProps<
    GridCampaignStatusCellProps,
    OwnProps
>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData, isGridScrolling } = state.grid;
    const { campaignId, columnName } = ownProps;
    const { view } = selectGridSourceParams(state);
    const key = getEditCellKey({
        id: campaignId,
        column: columnName,
        view
    });
    const isSaving =
        editCellsData[key] !== undefined ? editCellsData[key].isSaving : false;
    const error =
        editCellsData[key] !== undefined
            ? (editCellsData[key].error as string)
            : undefined;

    return {
        isSaving,
        error,
        isGridScrolling
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { columnName, campaignId, login } = ownProps;
    return {
        saveDayBudget: (value: DayBudgetValue) => {
            dispatch(
                updateCampaignDayBudgetInfoRemote(
                    {
                        campaignId,
                        value
                    },
                    login,
                    columnName
                )
            );
        }
    };
};

export const EditableCampaignStatusCellContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(GridCampaignStatusCell);
